// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-header h5 {
  margin-top: 0;
}

.col-sm-6.included {
  order: -1;
}

.head {
  text-align: center;
  border-bottom: 1px solid #dde2e7;
}

.audience {
  color: #293949;
}
.audience .panel {
  background: #fafafa;
  text-transform: uppercase;
  padding: 0.8rem 1rem;
  margin: 0.5rem 0 0;
  cursor: pointer;
  font-size: 0.9rem;
  transition: 0.3s;
}
.audience .panel:hover {
  color: #c00006;
}
.audience .card-body {
  padding: 1.5rem 1rem 1rem;
  border-top: 1px solid #ddd;
}
.audience .card-body .add-new {
  font-size: 0.9rem;
  color: #5d5f63;
  margin: 0;
  display: flex;
  justify-content: center;
}
.audience .card-body .add-new span {
  margin-right: 0.3rem;
}
.audience .card-body .add-new .entries-added {
  display: block;
}
.audience .card-body .add-new .no-entries {
  display: none;
}
.audience .card-body .add-new.empty {
  justify-content: flex-start;
}
.audience .card-body .add-new.empty .entries-added {
  display: none;
}
.audience .card-body .add-new.empty .no-entries {
  display: block;
}
.audience .card-body .add-new.empty .cta-btn {
  color: #ff0059;
}
.audience .card-body .add-new span.clickable {
  color: #293949;
  opacity: 0.7;
  transition: 0.2s;
  cursor: pointer;
}
.audience .card-body .add-new span.clickable:hover {
  opacity: 1;
}
.audience .audience-select {
  border-top: 1px solid #eee;
  padding: 0.5rem 1rem 1rem;
}
.audience .audience-select input[type=number] {
  margin-bottom: 1rem;
}

.modal-footer {
  justify-content: space-between;
}
.modal-footer .btns {
  display: flex;
  gap: 1rem;
}
.modal-footer .btns .btn {
  font-size: 15px;
  line-height: 1.5;
  border-radius: 3px;
  border: none;
  cursor: pointer;
  color: #fff;
}
.modal-footer .btns .btn-primary {
  background-color: #ff0059;
  padding: 9px 30px;
}
.modal-footer .btns .btn-secondary {
  background-color: #8f939e;
  padding: 6px 18px;
  font-size: 14px;
  margin-top: 9px;
}

.csv-input body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(to right, #8e24aa, #b06ab3);
  color: #d7d7ef;
}
.csv-input .file-drop-area {
  position: relative;
  display: flex;
  align-items: center;
  width: 450px;
  max-width: 100%;
  border: 1px dashed rgba(255, 255, 255, 0);
  border-radius: 3px;
  transition: 0.2s;
}
.csv-input .choose-file-button {
  flex-shrink: 0;
  background-color: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 3px;
  margin-right: 10px;
  font-size: 12px;
  text-transform: uppercase;
}
.csv-input .file-message {
  font-size: small;
  font-weight: 300;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.csv-input .file-input {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  cursor: pointer;
  opacity: 0;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
